import React from 'react'
import { Card } from 'react-components'

import { TrustbarItemTransport } from '@common/transports/deprecated-home-page-transport'
import { TrustBarItemContent, TrustBarItemIcon, TrustBarItemIconContainer } from './trustbar-item-styles'

interface TrustBarItemProps {
    trustbarItem: TrustbarItemTransport
}

export const TrustBarItem: React.FC<TrustBarItemProps> = ({ trustbarItem }) => (
    <Card backgroundColor="transparent">
        <TrustBarItemIconContainer>
            <TrustBarItemIcon src={trustbarItem.image.url} alt={trustbarItem.image.alt} />
        </TrustBarItemIconContainer>
        <TrustBarItemContent>{trustbarItem.text}</TrustBarItemContent>
    </Card>
)
